import type { P1Variant } from "./hero-with-typographic-reveal.tsx"

import * as UI from "@iyk/ui"

import { IYK_URL } from "../ui/links.ts"
import { Video } from "../ui/video.tsx"
import { Branded } from "./branded.tsx"

export const Hero = ({ text, p1Variant }: Props) => (
  <>
    <Variant p1Variant={p1Variant} />

    <div className="relative z-10 h-full flex flex-col items-center pointer-events-none">
      <header
        className="pt-6 shrink-0 flex flex-col gap-3 items-center justify-center"
        aria-label="IYK Postcard"
      >
        <a href={IYK_URL} target="_blank" rel="noreferrer" className="pointer-events-auto">
          <img
            src="https://assets.iyk-dev.app/postcards/iyk.svg"
            alt="IYK"
            width="28"
            height="28"
            className="size-7"
          />
        </a>
        <h1 className={UI.cx("text-xs-upper", classForText({ p1Variant }))}>
          <Branded with=" [*]">Postcard</Branded>
        </h1>
      </header>

      <div className="grow" />

      <div className="pb-20 md:pb-24">
        <p className={UI.cx("text-balance max-w-72 text-center", classForText({ p1Variant }))}>
          {text}
        </p>
      </div>
    </div>
  </>
)

const classForText = UI.cva([], {
  variants: {
    p1Variant: {
      A: "text-white",
      B: "text-gray-12",
      Custom: "text-white",
    },
  },
})

const Variant = ({ p1Variant }: { p1Variant: P1Variant }) => {
  switch (p1Variant) {
    case "A":
      return <TestA />
    case "B":
      return <TestB />
    case "Custom":
      return <Custom />
  }
}

const TestA = () => (
  <>
    <Video className="absolute inset-0 size-full object-cover hidden md:block" aria-hidden="true">
      <source
        src="https://assets.iyk-dev.app/postcards/hero/postcard-p1_test-a-16x9-compressed.mp4"
        type="video/mp4"
      />
    </Video>

    <Video className="absolute inset-0 size-full object-cover md:hidden" aria-hidden="true">
      <source
        src="https://assets.iyk-dev.app/postcards/hero/postcard-p1_test-a-9x16-compressed.mp4"
        type="video/mp4"
      />
    </Video>
  </>
)

const TestB = () => (
  <>
    <Video className="absolute inset-0 size-full object-cover md:block" aria-hidden="true">
      <source
        src="https://assets.iyk-dev.app/postcards/hero/Postcard_test-b_v3_16-9.mp4"
        type="video/mp4"
      />
    </Video>

    <Video className="absolute inset-0 size-full object-cover md:hidden" aria-hidden="true">
      <source
        src="https://assets.iyk-dev.app/postcards/hero/Postcard_test-b_v3_9-16.mp4"
        type="video/mp4"
      />
    </Video>
  </>
)

const Custom = () => (
  <img
    className="absolute inset-0 size-full object-cover"
    src="https://assets.iyk-dev.app/postcards/hero/b2b-hero.webp"
    alt="Someone tapping the Postcard with their phone"
  />
)

type Props = UI.HTMLElementProps<{ text: string; p1Variant: P1Variant }>
